import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    withStyles,
} from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const Delete = props => {
    let { classes, open, entityName, handleCloseSafe, handleCloseDanger, translations, deleting=false } = props;

    return (
        <Dialog
            open={open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['bulk_delete'] || 'Bulk delete'} {entityName}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['carefully_deleting_something'] || 'Be careful when deleting something.'}<br />
                    {translations['sure_want_delete'] || `Are you sure you want to delete `} {translations['these'] || 'these'} {`${entityName}`} {`${translations['data'] || 'data'}?`}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe} disabled={deleting}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleCloseDanger} variant="contained" className={classes.buttonDanger} disabled={deleting}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(Delete);